import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  query analytic_nailAppointment_getHourlyDistribution($branchId: ID!, $startTime: DateTime!, $endTime: DateTime!) {
    analytic_nailAppointment_getHourlyDistribution(branchId: $branchId, startTime: $startTime, endTime: $endTime) {
      hour
      appointmentCount
    }
  }
`);

export default function useAppointmentHourlyDistribution(branchId: string, startTime: string, endTime: string) {
  return useQuery(QUERY, {
    variables: { branchId, startTime, endTime },
    skip: !branchId || !startTime || !endTime,
  });
}
